import { expenseCategoryAddApi } from "../../api/expenseCategory/expenseCategoryAddApi"

type PayloadShape = Parameters<typeof expenseCategoryAddApi>[0]

export async function expenseCategoryAddService(payload: PayloadShape, token: string) {
	return await expenseCategoryAddApi(payload, token)
}
